import { FlagGetter } from "@/FeatureFlag";

export function isWtm2Enabled(flag: FlagGetter): boolean {
  return flag("webTrackerMonitoringWtm2");
}
